import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query fetchUserGroupJoinRequests($limit: Int!, $page: Int!) {
    userGroupJoinRequests(limit: $limit, page: $page) {
      totalDocs
      docs {
        group {
          id
        }
        status
      }
    }
  }
`

export interface UserGroupJoinRequestsQueryInput {
  page: number
  limit: number
}

export interface UserGroupJoinRequestsQueryOutput {
  userGroupJoinRequests: {
    totalDocs: number
    docs: {
      status: string
      group: {
        id: string
      }
    }[]
  }
}

const defaultVariables: UserGroupJoinRequestsQueryInput = {
  page: 1,
  limit: 100,
}

export const useUserGroupJoinRequestsQuery = (
  options?: QueryHookOptions<UserGroupJoinRequestsQueryOutput, UserGroupJoinRequestsQueryInput>
) =>
  usePersistedCacheQuery<UserGroupJoinRequestsQueryOutput, UserGroupJoinRequestsQueryInput>(query, {
    variables: defaultVariables,
    ...options,
  })

export const userGroupJoinRequestsQuery = { query, defaultVariables }
